import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
    if (to.path !== '/oci-punchout') return;
  
    const accessToken = to.query.accessToken as string | undefined;
  
    const userStore = useUserStore();
    const { loginWithToken } = useDjustAuth();
    const { load: loadUserData } = useUserData();
  
    if (process.server) return;
  
    if (!accessToken || userStore.isAuthenticated) {
      return navigateTo('/');
    }
  
    const success = await loginWithToken({ accessToken });
  
    if (!success) {
      console.warn('Échec de login avec accessToken');
      return navigateTo('/auth/login?oci=true');
    }
  
    await loadUserData({ cart: true, quotes: true, buyingLists: true });
  
    const queryParams = { ...to.query };
    delete queryParams.accessToken;
  
    Object.entries(queryParams).forEach(([key, value]) => {
      if (typeof value === 'string') {
        localStorage.setItem(key, value);
      }
    });
  
    // Redirection finale
    return navigateTo({ path: '/', query: { oci: 'true' } });
  });
